import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { DEFAULT_FL_FILTER_RANGE } from 'app/components/dashboard/network/AbstractMapView';
import AppContext from 'app/common/context/AppContext';
import { MapLayerType, MapLayerUtils, MapObjectType, NatLayerUtils } from 'app/components/dashboard/network/map/Map';
import { GetNatTracksRequest } from 'app/model/SOL49';
import { ServiceFactory } from 'app/service/ServiceFactory';
import { OTSRoute } from 'app/model/CORE';
import FlightLevelUtils from 'app/common/util/FlightLevelUtils';
import { UnityApplication } from 'app/unity/UnityApplication';
import { NMUI4DContext, NMUI4DContextProps } from 'app/common/context/NMUI4DContext';

export class NatTracksPanel extends PureComponent<{ onNatTracksImgUpdate: (img: string) => void }> {
    public static contextType = NMUI4DContext;
    private nmui4dContext?: NMUI4DContextProps;

    componentDidMount(): void {
        this.nmui4dContext = this.context as NMUI4DContextProps;

        this.refreshNatTrackLayer();
    }

    private refreshNatTrackLayer = () => {
        const natTracksLayer = {
            objectsToDisplay: undefined,
            selection: [],
            label: 'NAT',
            mapType: [MapObjectType.NAT_TRACK],
            priority: 5.2,
            showLabel: true,
            active: true,
            type: MapLayerType.ENV,
            id: 7,
            parameters: {
                [NatLayerUtils.NAT_LAYER_LAST_UPDATE_PARAMETER]: null,
            },
        };
        const request: GetNatTracksRequest = {
            period: AppContext.getTodayPeriod(),
            day: AppContext.getMonitoredDay(),
        };
        ServiceFactory.sol49Service()
            .getNatTracks(request)
            .then(reply => {
                if (!reply.error) {
                    natTracksLayer.objectsToDisplay = MapLayerUtils.toObjectToDisplayArray(
                        reply.data.natTracks,
                        MapObjectType.NAT_TRACK,
                    );
                    const tracksToDisplay = natTracksLayer.objectsToDisplay.map(obj => obj.object as OTSRoute);
                    // this.coreMapRef.current?.refreshLayer(
                    //     natTracksLayer,
                    //     tracksToDisplay,
                    //     AppContext.getTodayPeriod(),
                    //     { min: FlightLevelUtils.ON_GROUND_LEVEL, max: FlightLevelUtils.UNLIMITED_LEVEL },
                    // );
                }
            });
    };

    render() {
        // NOTE(bjarne): In mapless mode the UnityApplication is already created in App.tsx.
        return (
            <Flex className="inp-nat-tracks-map-panel" style={{ height: '70em' }}>
                {!this.nmui4dContext?.isMapless && <UnityApplication></UnityApplication>}
            </Flex>
        );
    }
}
